import React, { useCallback, useState } from 'react';
import Button from '../../components/ui/Button/Button';
import { EInputType, IInputField } from '../../components/ui/Input/Input';
import classes from './Auth.module.scss';
import { useInputs } from '../ui/Input/useInputs';
import { IAuth } from '../../services/auth-service';
import ErrorsAlert from '../ErrorsAlert/ErrorsAlert';
import { useAuthContext } from '../../context/auth-context';

import { usePasswordResetModal } from './usePasswordResetModal';

export enum EAuth {
  username = "username",
  password = "password",
};

const Auth: React.FC = () => {

  const { createInput, submit, inputs } = useAuthInputs();
  const { login, loginWithGoogle, loginWithMicrosoft, errors, isLoggingIn } = useAuthContext();
  const openPasswordResetModal = usePasswordResetModal();

  const submitHandler = useCallback(async () => {
    const data = await submit();
    if (data) {
      if (data.username) {
        data.username = data.username.trim();
      }
      login(data);
    }
  }, [login, submit]);

  const forgotPasswordHandler = () => {
    const currentUsername = inputs[EAuth.username]?.value as string;
    openPasswordResetModal(currentUsername || "");
  };

  return (
    <div className={classes.Container}>
      <div className={classes.LoginBox}>
        <div className={classes.Title}>Sign In</div>
        <div className={classes.SubTitle}>Access Touring Cars Agent portal</div>
        
        <form onSubmit={(e) => { e.preventDefault(); submitHandler(); }}>
          <div className={classes.Inputs}>
            {createInput(EAuth.username)}
            {createInput(EAuth.password)}
          </div>
          <button type="submit" style={{ display: 'none' }} />

          <div style={{ textAlign: 'right', marginTop: '0.25rem', marginBottom: '0.75rem' }}>
            <button
              type="button"
              onClick={forgotPasswordHandler}
              style={{
                background: 'none',
                border: 'none',
                color: '#2563eb',
                cursor: 'pointer',
                fontSize: '0.85rem',
                textDecoration: 'underline',
                padding: 0
              }}
            >
              Forgot password?
            </button>
          </div>

          <div className={classes.ButtonContainer}>
            <Button onClick={submitHandler} className={classes.Button} loading={isLoggingIn}>
              Login
            </Button>
          </div>
        </form>

        <div className={classes.Divider}>
          <span>OR</span>
        </div>

        <div className={classes.SocialContainer}>
          <button className={classes.SocialButton} onClick={loginWithGoogle}>
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
            <span>Login with Google</span>
          </button>
          
          <button className={`${classes.SocialButton} ${classes.Microsoft}`} onClick={loginWithMicrosoft}>
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg" alt="Microsoft" />
            <span>Login with Microsoft</span>
          </button>
        </div>

        {errors && errors.length > 0 && <ErrorsAlert errors={errors} />}
      </div>
    </div>
  );
};

const useAuthInputs = (data?: IAuth) => {
  const [inputs, setInputs] = useState<IInputField>({
    [EAuth.username]: {
      type: EInputType.text,
      label: "Username",
      value: "",
    },
    [EAuth.password]: {
      type: EInputType.password,
      label: "Password",
      value: "",
    },
  });

  const { createInput, submit } = useInputs({ data, inputs, setInputs });
  return { createInput, submit, inputs, setInputs };
};

export default Auth;

